<script>
export default {
  name: 'IconDolarCircle',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template
  ><svg
    :width="size"
    :height="size"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9375 20.7798H16.75C17.5625 20.7798 18.2375 20.0548 18.2375 19.1798C18.2375 18.0923 17.85 17.8798 17.2125 17.6548L15.95 17.2173V20.7798H15.9375Z"
      :fill="color"
    />
    <path
      d="M14.9626 3.2549C8.06258 3.2799 2.47508 8.8924 2.50008 15.7924C2.52508 22.6924 8.13758 28.2799 15.0376 28.2549C21.9376 28.2299 27.5251 22.6174 27.5001 15.7174C27.4751 8.8174 21.8626 3.2424 14.9626 3.2549ZM17.8251 15.8799C18.8001 16.2174 20.1126 16.9424 20.1126 19.1799C20.1126 21.1049 18.6001 22.6549 16.7501 22.6549H15.9376V23.3799C15.9376 23.8924 15.5126 24.3174 15.0001 24.3174C14.4876 24.3174 14.0626 23.8924 14.0626 23.3799V22.6549H13.6126C11.5626 22.6549 9.90008 20.9299 9.90008 18.8049C9.90008 18.2924 10.3251 17.8674 10.8376 17.8674C11.3501 17.8674 11.7751 18.2924 11.7751 18.8049C11.7751 19.8924 12.6001 20.7799 13.6126 20.7799H14.0626V16.5549L12.1751 15.8799C11.2001 15.5424 9.88758 14.8174 9.88758 12.5799C9.88758 10.6549 11.4001 9.1049 13.2501 9.1049H14.0626V8.3799C14.0626 7.8674 14.4876 7.4424 15.0001 7.4424C15.5126 7.4424 15.9376 7.8674 15.9376 8.3799V9.1049H16.3876C18.4376 9.1049 20.1001 10.8299 20.1001 12.9549C20.1001 13.4674 19.6751 13.8924 19.1626 13.8924C18.6501 13.8924 18.2251 13.4674 18.2251 12.9549C18.2251 11.8674 17.4001 10.9799 16.3876 10.9799H15.9376V15.2049L17.8251 15.8799Z"
      :fill="color"
    />
    <path
      d="M11.7749 12.5925C11.7749 13.68 12.1624 13.8925 12.7999 14.1175L14.0624 14.555V10.98H13.2499C12.4374 10.98 11.7749 11.705 11.7749 12.5925Z"
      :fill="color"
    />
  </svg>
</template>
